<template>
  <div
    style="align-items: flex-start; background-color: #EEF2F3; box-sizing: border-box; display: flex; flex-direction: column; gap: 0px; height: fit-content; justify-content: flex-start; overflow: hidden; min-height: 100vh; width: 100%"
  >
    <div
      style="align-items: flex-start; background-color: #EEF2F3; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; padding: 12px; width: 100%"
    >
      <div
        style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 13px; width: 100%"
      >
        <div
          style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #102130; font-family: "Noto Serif SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            报告信息
          </div>
        </div>
        <div
          style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #647786; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            被背调人
          </div>
          <div
            style='box-sizing: border-box; color: #102130; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 13px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            {{ person.name }} / {{ person.idCard }}
          </div>
        </div>
        <div
          style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #647786; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            报告生成时间
          </div>
          <div
            style='box-sizing: border-box; color: #102130; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 13px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            {{ generatedTime }}
          </div>
        </div>
        <div
          style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 34px; justify-content: space-between; width: 100%"
        >
          <div
            style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 5px; height: fit-content; justify-content: flex-start; width: fit-content"
          >
            <div
              style='box-sizing: border-box; color: #2A4051; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
            >
              综合风险
            </div>
            <!-- <div
              style="box-sizing: border-box; color: #F5A623; font-family: Arial, system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap"
            >
              ⓘ
            </div> -->
          </div>
          <div
            style='box-sizing: border-box; font-family: "Noto Serif SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
            :style="{ color: riskLevel2styles[risk.level]?.color }"
          >
            {{ risk.levelDescription }}
          </div>
        </div>
        <div
          style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #526B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 500; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            综合得分 {{ risk.score }} / 100
          </div>
          <div
            style='box-sizing: border-box; color: #9A5B0A; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 17px; font-style: normal; font-weight: 500; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            {{ stars(risk.score) }}
          </div>
        </div>
      </div>
      <div
        style='box-sizing: border-box; color: #102130; font-family: "Noto Serif SC", system-ui, sans-serif; font-size: 18px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
      >
        报告正文
      </div>
      <div
        style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
      >
        <div
          style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
        >
          <div
            style="align-items: center; background-color: #0B263F; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 25px; justify-content: center; width: 25px"
          >
            <div
              style="box-sizing: border-box; color: #FFFFFF; font-family: Inter, system-ui, sans-serif; font-size: 10px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap"
            >
              01
            </div>
          </div>
          <div
            style='box-sizing: border-box; color: #102130; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            身份信息核实
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex: 1 1 0; gap: 0px; height: 1px; justify-content: flex-start"
          ></div>
          <div
            style="align-items: flex-start; background-color: #E3F5ED; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; padding: 3px 6px; width: fit-content"
          >
            <div
              style='box-sizing: border-box; color: #147052; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
            >
              {{ identity.consistency }}
            </div>
          </div>
        </div>
        <div
          style="align-items: center; background-color: #F0F4F5; border-radius: 5px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; padding: 6px 9px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #526B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            维度得分 {{ identity.score }} / 100
          </div>
          <div
            style='box-sizing: border-box; color: #94690F; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            {{ stars(identity.score) }}
          </div>
        </div>
        <div
          style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 7px; height: fit-content; justify-content: flex-start; width: 100%"
        >
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
            >
              姓名
            </div>
            <div
              style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
            >
              {{ identity.name }}
            </div>
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
            >
              身份证号
            </div>
            <div
              style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
            >
              {{ identity.idCard }}
            </div>
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
            >
              出生日期
            </div>
            <div
              style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
            >
              {{ identity.birthday }}
            </div>
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
            >
              国家／地区
            </div>
            <div
              style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
            >
              {{ identity.country }}
            </div>
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
            >
              一致性结果
            </div>
            <div
              style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
            >
              {{ identity.consistency }}
            </div>
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
            >
              核验时间
            </div>
            <div
              style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
            >
              {{ identity.verifyTime }}
            </div>
          </div>
        </div>
      </div>
      <div
        style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
      >
        <div
          style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
        >
          <div
            style="align-items: center; background-color: #0B263F; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 25px; justify-content: center; width: 25px"
          >
            <div
              style="box-sizing: border-box; color: #FFFFFF; font-family: Inter, system-ui, sans-serif; font-size: 10px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap"
            >
              02
            </div>
          </div>
          <div
            style='box-sizing: border-box; color: #102130; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            项目经历核查
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex: 1 1 0; gap: 0px; height: 1px; justify-content: flex-start"
          ></div>
          <div
            style="align-items: flex-start; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; padding: 3px 6px; width: fit-content"
            :style="riskLevel2styles[experience.riskLevel]"
          >
            <div
              style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
            >
              {{ experience.riskLevelDescription }}
            </div>
          </div>
        </div>
        <div
          style="align-items: center; background-color: #F0F4F5; border-radius: 5px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; padding: 6px 9px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #526B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            维度得分 {{ experience.score }} / 100
          </div>
          <div
            style='box-sizing: border-box; color: #94690F; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            {{ stars(experience.score) }}
          </div>
        </div>
        <div
          v-for="(rec, idx) in experience.records"
          :key="idx"
          style="align-items: flex-start; background-color: #FFFFFF; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #E2E8EC; padding: 11px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #233E52; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
          >
            {{ rec.projectName }}
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 7px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                项目编号
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.projectNo }}
              </div>
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                总包单位
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.contractorName }}
              </div>
            </div>
            <div
              v-if="rec.subContractorName"
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                分包单位
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.subContractorName }}
              </div>
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                班组／工种
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.teamWorkType }}
              </div>
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                入场时间
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.entryTime }}
              </div>
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                退场时间
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.exitTime || '至今' }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
      >
        <div
          style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
        >
          <div
            style="align-items: center; background-color: #0B263F; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 25px; justify-content: center; width: 25px"
          >
            <div
              style="box-sizing: border-box; color: #FFFFFF; font-family: Inter, system-ui, sans-serif; font-size: 10px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap"
            >
              03
            </div>
          </div>
          <div
            style='box-sizing: border-box; color: #102130; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            履约纠纷核查
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex: 1 1 0; gap: 0px; height: 1px; justify-content: flex-start"
          ></div>
          <div
            style="align-items: flex-start; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; padding: 3px 6px; width: fit-content"
            :style="riskLevel2styles[dispute.riskLevel]"
          >
            <div
              style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
            >
              {{ dispute.riskLevelDescription }}
            </div>
          </div>
        </div>
        <div
          style="align-items: center; background-color: #F0F4F5; border-radius: 5px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; padding: 6px 9px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #526B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            维度得分 {{ dispute.score }} / 100
          </div>
          <div
            style='box-sizing: border-box; color: #94690F; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            {{ stars(dispute.score) }}
          </div>
        </div>
        <div
          v-for="(rec, idx) in dispute.records"
          :key="idx"
          style="align-items: flex-start; background-color: #FFFFFF; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #E2E8EC; padding: 11px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #233E52; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
          >
            {{ rec.type }}
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 7px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                投诉时间
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.complaintTime }}
              </div>
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                关联项目
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.projectName }}
              </div>
            </div>
            <div
              v-if="rec.teamName"
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                班组
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.teamName }}
              </div>
            </div>
            <div
              v-if="rec.handleStatus"
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                处理状态
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.handleStatus }}
              </div>
            </div>
            <div
              v-if="rec.note"
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                处理意见
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.note }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
      >
        <div
          style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
        >
          <div
            style="align-items: center; background-color: #0B263F; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 25px; justify-content: center; width: 25px"
          >
            <div
              style="box-sizing: border-box; color: #FFFFFF; font-family: Inter, system-ui, sans-serif; font-size: 10px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap"
            >
              04
            </div>
          </div>
          <div
            style='box-sizing: border-box; color: #102130; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            不良记录核查
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex: 1 1 0; gap: 0px; height: 1px; justify-content: flex-start"
          ></div>
          <div
            style="align-items: flex-start; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; padding: 3px 6px; width: fit-content"
            :style="riskLevel2styles[adverse.riskLevel]"
          >
            <div
              style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
            >
              {{ adverse.riskLevelDescription }}
            </div>
          </div>
        </div>
        <div
          style="align-items: center; background-color: #F0F4F5; border-radius: 5px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; padding: 6px 9px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #526B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            维度得分 {{ adverse.score }} / 100
          </div>
          <div
            style='box-sizing: border-box; color: #94690F; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            {{ stars(adverse.score) }}
          </div>
        </div>
        <div
          v-for="(rec, idx) in adverse.records"
          :key="idx"
          style="align-items: flex-start; background-color: #FFFFFF; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #E2E8EC; padding: 11px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #233E52; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
          >
            不良记录 {{ rec.sysNo }}
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 7px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                人员
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.name }}
              </div>
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                关联项目
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.projectName }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
      >
        <div
          style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
        >
          <div
            style="align-items: center; background-color: #0B263F; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 25px; justify-content: center; width: 25px"
          >
            <div
              style="box-sizing: border-box; color: #FFFFFF; font-family: Inter, system-ui, sans-serif; font-size: 10px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap"
            >
              05
            </div>
          </div>
          <div
            style='box-sizing: border-box; color: #102130; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            职业证书核实
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex: 1 1 0; gap: 0px; height: 1px; justify-content: flex-start"
          ></div>
          <div
            style="align-items: flex-start; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; padding: 3px 6px; width: fit-content"
            :style="riskLevel2styles[vocational.riskLevel]"
          >
            <div
              style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
            >
              {{ vocational.riskLevelDescription }}
            </div>
          </div>
        </div>
        <div
          style="align-items: center; background-color: #F0F4F5; border-radius: 5px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; padding: 6px 9px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #526B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            维度得分 {{ vocational.score }} / 100
          </div>
          <div
            style='box-sizing: border-box; color: #94690F; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            {{ stars(vocational.score) }}
          </div>
        </div>
        <div
          v-for="(rec, idx) in vocational.records"
          :key="idx"
          style="align-items: flex-start; background-color: #FFFFFF; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #E2E8EC; padding: 11px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #233E52; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
          >
            {{ rec.name }}
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 7px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                证书编号
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.no }}
              </div>
            </div>
            <div
              v-if="rec.levelName"
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                证书等级
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.levelName }}
              </div>
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                有效期限
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.validBeginDate }} 至 {{ rec.validEndDate }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!vocational.records.length"
          style='box-sizing: border-box; color: #526B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
        >
          未查询到证书记录
        </div>
      </div>
      <div
        style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
      >
        <div
          style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
        >
          <div
            style="align-items: center; background-color: #0B263F; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 25px; justify-content: center; width: 25px"
          >
            <div
              style="box-sizing: border-box; color: #FFFFFF; font-family: Inter, system-ui, sans-serif; font-size: 10px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap"
            >
              06
            </div>
          </div>
          <div
            style='box-sizing: border-box; color: #102130; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            特种证书核实
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex: 1 1 0; gap: 0px; height: 1px; justify-content: flex-start"
          ></div>
          <div
            style="align-items: flex-start; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; padding: 3px 6px; width: fit-content"
            :style="riskLevel2styles[special.riskLevel]"
          >
            <div
              style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
            >
              {{ special.riskLevelDescription }}
            </div>
          </div>
        </div>
        <div
          style="align-items: center; background-color: #F0F4F5; border-radius: 5px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; padding: 6px 9px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #526B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            维度得分 {{ special.score }} / 100
          </div>
          <div
            style='box-sizing: border-box; color: #94690F; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            {{ stars(special.score) }}
          </div>
        </div>
        <div
          v-for="(rec, idx) in special.records"
          :key="idx"
          style="align-items: flex-start; background-color: #FFFFFF; border-radius: 6px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #E2E8EC; padding: 11px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #233E52; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
          >
            {{ rec.name }}
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 7px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                证书编号
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.no }}
              </div>
            </div>
            <div
              v-if="rec.levelName"
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                证书等级
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.levelName }}
              </div>
            </div>
            <div
              style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
            >
              <div
                style='box-sizing: border-box; color: #647786; flex-shrink: 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 66px'
              >
                有效期限
              </div>
              <div
                style='box-sizing: border-box; color: #233E52; flex: 1 1 0; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left'
              >
                {{ rec.validBeginDate }} 至 {{ rec.validEndDate }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!special.records.length"
          style='box-sizing: border-box; color: #526B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
        >
          未查询到证书记录
        </div>
      </div>
      <div
        style="align-items: flex-start; background-color: #FBFAF6; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 10px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 14px; width: 100%"
      >
        <div
          style="align-items: center; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 8px; height: fit-content; justify-content: flex-start; width: 100%"
        >
          <div
            style="align-items: center; background-color: #0B263F; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 25px; justify-content: center; width: 25px"
          >
            <div
              style="box-sizing: border-box; color: #FFFFFF; font-family: Inter, system-ui, sans-serif; font-size: 10px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap"
            >
              07
            </div>
          </div>
          <div
            style='box-sizing: border-box; color: #102130; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            合规核验
          </div>
          <div
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: row; flex: 1 1 0; gap: 0px; height: 1px; justify-content: flex-start"
          ></div>
          <div
            style="align-items: flex-start; border-radius: 4px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: flex-start; padding: 3px 6px; width: fit-content"
            :style="riskLevel2styles[compliance.riskLevel]"
          >
            <div
              style='box-sizing: border-box; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
            >
              {{ compliance.riskLevelDescription }}
            </div>
          </div>
        </div>
        <div
          style="align-items: center; background-color: #F0F4F5; border-radius: 5px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: fit-content; justify-content: space-between; padding: 6px 9px; width: 100%"
        >
          <div
            style='box-sizing: border-box; color: #526B7E; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            维度得分 {{ compliance.score }} / 100
          </div>
          <div
            style='box-sizing: border-box; color: #94690F; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
          >
            {{ stars(compliance.score) }}
          </div>
        </div>
        <div
          v-if="compliance.riskLevel === '00'"
          style='box-sizing: border-box; color: #233E52; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
        >
          本次核验范围内未发现需关注的合规风险
        </div>
        <div
          style='box-sizing: border-box; color: #647786; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 22px; text-align: left; width: 100%'
        >
          核验范围：{{ compliance.scope }}
          <br />
          核验时间：{{ compliance.verifyTime }}
        </div>
      </div>
      <div
        style="align-items: flex-start; background-color: #FFFFFF; border-radius: 8px; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 16px; height: fit-content; justify-content: flex-start; outline-offset: -0.5px; outline: 1px solid #D6E0E6; padding: 16px; width: 100%"
      >
        <div
          style='box-sizing: border-box; color: #24384B; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 16px; font-style: normal; font-weight: 700; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
        >
          报告数据来源
        </div>
        <template v-for="(ds, idx) in dataSources">
          <div
            v-if="idx > 0"
            :key="'sep' + idx"
            style="background-color: #E8EDF1; box-sizing: border-box; flex-shrink: 0; height: 1px; width: 100%"
          ></div>
          <div
            :key="`src${idx}`"
            style="align-items: flex-start; box-sizing: border-box; display: flex; flex-direction: column; flex-shrink: 0; gap: 4px; height: fit-content; justify-content: flex-start; width: 100%"
          >
            <div
              style='box-sizing: border-box; color: #24384B; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 500; letter-spacing: 0px; line-height: 21px; text-align: left; width: 100%'
            >
              {{ ds.sourceName }}
            </div>
            <div
              style='box-sizing: border-box; color: #647786; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12.5px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 100%'
            >
              {{ ds.items }}
            </div>
          </div>
        </template>
      </div>
      <div
        style='box-sizing: border-box; color: #647786; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 12px; font-style: normal; font-weight: 400; letter-spacing: 0px; line-height: 19px; text-align: left; width: 100%'
      >
        报告内容仅供本次授权核查及用工审核参考
      </div>
      <div
        style="align-items: center; background-color: #0B263F; border-radius: 7px; box-sizing: border-box; display: flex; flex-direction: row; flex-shrink: 0; gap: 0px; height: 50px; justify-content: center; width: 100%"
        @click="downloadReport"
      >
        <svg
          data-icon-name="download"
          data-icon-set="lucide"
          viewBox="0 0 13.99993896484375 14"
          preserveAspectRatio="xMidYMid meet"
          xmlns="http://www.w3.org/2000/svg"
          style="box-sizing: border-box; flex-shrink: 0; height: 18px; width: 18px"
        >
          <path
            d="M6.84619 1.18945q-0.25293 0.08545-0.37939 0.30762l-0.04102 0.08545 0 5.75244-0.99463-0.99463q-0.62891-0.62891-0.83398-0.81689-0.20166-0.18799-0.25635-0.21875-0.19824-0.08203-0.3999-0.02393-0.20166 0.05469-0.32813 0.21533-0.12646 0.16064-0.11279 0.36914l0 0.02735q0.01367 0.11279 0.06836 0.19824 0.07178 0.11279 0.36572 0.42041l1.20313 1.20313q1.52783 1.52441 1.59619 1.56884 0.05811 0.02734 0.10596 0.03418 0.04785 0.00684 0.16064 0.00684 0.11279 0 0.16064-0.00684 0.04785-0.00684 0.10596-0.03418 0.06836-0.04443 1.59619-1.56884 1.03564-1.03564 1.28516-1.30225 0.25293-0.2666 0.29736-0.33496 0.0957-0.22559 0.01026-0.44776-0.08203-0.22559-0.32129-0.33837-0.08203-0.02734-0.22217-0.02735l-0.02734 0q-0.12646 0-0.19825 0.02735-0.0957 0.05811-0.30761 0.25293-0.15381 0.15381-0.69727 0.70068l-1.10742 1.09033 0-5.75244-0.04102-0.08545q-0.09912-0.18115-0.28027-0.2666-0.08545-0.04102-0.22559-0.04785-0.14014-0.00684-0.18115 0.00683z m-5.25 7q-0.25293 0.08545-0.37939 0.30762l-0.04102 0.08545 0.01367 2.60449q0 0.23584 0.02735 0.30762 0.14014 0.48877 0.46826 0.82031 0.33154 0.32813 0.82031 0.46826 0.08545 0.02734 0.71436 0.02735l3.78027 0.01367 3.78027-0.01367q0.62891 0 0.71436-0.02735 0.48877-0.14014 0.81689-0.46826 0.33154-0.33154 0.47168-0.82031 0.02734-0.07178 0.02735-0.30762l0.01367-2.60449-0.04102-0.08545q-0.09912-0.16748-0.28027-0.2666-0.05811-0.02734-0.09912-0.04102-0.04102-0.01367-0.15381-0.01367-0.11279 0-0.15381 0.01367-0.04101 0.01367-0.09912 0.04102-0.18115 0.09912-0.28027 0.2666l-0.04102 0.08545-0.01367 2.63183-0.04102 0.09913q-0.14014 0.27685-0.43408 0.33496-0.09912 0.02734-4.18701 0.02734-4.08789 0-4.18701-0.02734-0.29395-0.05811-0.43408-0.33496l-0.04102-0.09913-0.01367-2.63183-0.04102-0.08545q-0.09912-0.18115-0.28027-0.2666-0.08545-0.04102-0.22559-0.04785-0.14014-0.00684-0.18115 0.00683z"
            fill="#FFFFFF"
          ></path>
        </svg>
        <div
          style='box-sizing: border-box; color: #FFFFFF; font-family: "Noto Sans SC", system-ui, sans-serif; font-size: 14px; font-style: normal; font-weight: 600; letter-spacing: 0px; line-height: normal; text-align: left; white-space: nowrap'
        >
          下载报告
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import req from '../../../req';

function stars(score) {
  const filled = Math.max(0, Math.min(5, Math.round((score || 0) / 20)));
  return '★'.repeat(filled) + '☆'.repeat(5 - filled);
}

function emptyDim() {
  return {
    score: 0, riskLevel: '', riskLevelDescription: '', records: [],
  };
}

const riskLevel2styles = {
  '00': { backgroundColor: '#E3F5ED', color: '#147052' },
  '01': { backgroundColor: '#E3F5ED', color: '#147052' },
  '02': { backgroundColor: '#FFF7E8', color: '#9A5B0A' },
  '03': { backgroundColor: '#FFF4F3', color: '#A22031' },
  '04': { backgroundColor: '#FFF4F3', color: '#A22031' },
};

export default {
  name: 'WorkerCheckReportFull',
  data() {
    return {
      person: { name: '', idCard: '', headImg: '' },
      generatedTime: '',
      risk: { level: '', levelDescription: '', riskValue: 0 },
      identity: {
        name: '',
        idCard: '',
        birthday: '',
        country: '',
        consistency: '',
        verifyTime: '',
        score: 0,
      },
      experience: emptyDim(),
      dispute: emptyDim(),
      adverse: emptyDim(),
      vocational: emptyDim(),
      special: emptyDim(),
      compliance: {
        score: 0, riskLevel: '', riskLevelDescription: '', scope: '', verifyTime: '',
      },
      dataSources: [],
      riskLevel2styles,
    };
  },
  mounted() {
    const { sessionId } = this.$route.query;
    if (sessionId) {
      req.session.set(sessionId);
    }
    this.pid = null;
    this.fetchDetail();
  },
  methods: {
    /**
     * 获取我的权限列表
     */
    async getAuthority() {
      const { pid } = this;
      try {
        const res = await req.authority.getCrtAuthorityList({
          childProjectId: pid,
          projectId: pid,
        });
        if (res.code !== 0) {
          throw new Error(res.msg);
        }
        const codeMap = res.data.projectPermissions.reduce((prev, cur) => ({ ...prev, [cur.code]: cur }), {});
        const VIEW_AI_CHECK_DATA = '70001001'; // 查看AI背调数据
        const VIEW_AI_CHECK_REPORT = '70001004'; // 查看AI背调报告
        const MANAGE_AI_CHECK_INITIATE = '70001002'; // 发起背调
        const MANAGE_AI_CHECK_DOWNLOAD = '70001003'; // 下载报告
        return {
          viewAiCheckData: !!codeMap[VIEW_AI_CHECK_DATA],
          viewAiCheckReport: !!codeMap[VIEW_AI_CHECK_REPORT],
          manageAiCheckInitiate: !!codeMap[MANAGE_AI_CHECK_INITIATE],
          manageAiCheckDownload: !!codeMap[MANAGE_AI_CHECK_DOWNLOAD],
        };
      } catch (err) {
        req.err.show(err);
        return {};
      }
    },
    async downloadReport() {
      const { reportId } = this.$route.query;
      if (!reportId) {
        req.err.show('缺少报告ID');
        return;
      }
      const { manageAiCheckDownload } = await this.getAuthority();
      if (!manageAiCheckDownload) {
        req.err.show('您暂无权限，请联系超管授权');
        return;
      }
      const key = '__wxjs_environment';
      if (window[key] === 'miniprogram') {
        wx.miniProgram.navigateTo({ url: `/pages/ai_check/export/index?reportId=${reportId}` });
        return;
      }
      this.$router.push({
        name: 'ai_check.worker_check_report_full',
        query: { reportId },
      });
    },
    stars,
    fetchDetail() {
      const { reportId } = this.$route.query;
      if (!reportId) {
        req.err.show('缺少报告ID');
        return;
      }
      req.aiCheck
        .reportDetail(reportId)
        .then((res) => {
          if (res.code !== 0) {
            req.err.show(res);
            return;
          }
          const data = res.data || {};
          const dim = (d) => Object.assign(emptyDim(), d || {}, { records: (d && d.records) || [] });
          this.person = data.person || this.person;
          this.generatedTime = data.generatedTime || '';
          this.risk = data.risk || this.risk;
          this.identity = data.identity || this.identity;
          this.experience = dim(data.experience);
          this.dispute = dim(data.dispute);
          this.adverse = dim(data.adverse);
          this.vocational = dim(data.vocational);
          this.special = dim(data.special);
          this.compliance = data.compliance || this.compliance;
          this.dataSources = data.dataSources || [];
          this.pid = data.projectId || '';
        })
        .catch((err) => {
          req.err.show(err);
        });
    },
  },
};
</script>
